import { GlobalNotificationType, GlobalNotification } from './global-notification';

export class GlobalWarning extends GlobalNotification {
	constructor(message: string) {
		super(message, GlobalNotificationType.WARNING);
	}
}